import { useEffect, useState } from "react";
// @mui
import {
  Button,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Select from "@mui/material/Select";
import Iconify from "../iconify";
import AssetsDialog from "./AssetsDialog";
import { FormGroup } from "@mui/material";
import { createBlobInContainer } from "../../utils/azureBlob";
// ----------------------------------------------------------------------

const defaultState = {
  icon: "",
  has_prizing_image: false,
  is_private: false,
  prize: false,
};
export default function LeagueDialog(props) {
  const [league, setLeague] = useState(props.league || defaultState);
  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (props.league !== null) {
      setLeague(props.league);
    }
  }, [props]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setLeague((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLeague(defaultState);
    props.onSuccessHandler(league);
  };
  const onCancel = () => {
    setLeague(defaultState);
    props.onClose();
  };
  const onChoseAsset = (assetUrl) => {
    setLeague((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const handleChangetype = (event) => {
    setLeague((prevState) => ({
      ...prevState,
      type: event.target.value,
    }));
  };

  const uploadFiles = (event) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;
      let key = "icon";
      if (event.target.id === "select-image") {
        key = "banner_url";
      }
      if (event.target.id === "select-background") {
        key = "background";
      }
      let uploadPromises = [];
      uploadPromises.push(createBlobInContainer(files[0]));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);

          const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
          const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;

          setLeague((prevState) => ({
            ...prevState,
            [key]: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${files[0].name}`,
          }));
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {props.league === null ? "Create" : "Edit"} Custom League
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="order"
                  label="Order"
                  fullWidth
                  value={league.order}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="name"
                  label="Name"
                  fullWidth
                  value={league.name}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="sponsor_slug"
                  label="Sponsor slug"
                  fullWidth
                  value={league.sponsor_slug}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="vanity_slug"
                  label="Vanity slug"
                  fullWidth
                  value={league.vanity_slug}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="passcode"
                  label="Passcode"
                  fullWidth
                  value={league.passcode}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="google_ads_tag"
                  label="Google Ads Tag"
                  fullWidth
                  value={league.google_ads_tag}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="type-select-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={league?.type ? league.type : ""}
                    label="Type"
                    onChange={handleChangetype}
                  >
                    <MenuItem value="CLUB">CLUB</MenuItem>
                    <MenuItem value="FRIENDS">FRIENDS</MenuItem>
                    <MenuItem value="PARTNER">PARTNER</MenuItem>
                    <MenuItem value="OFFICIAL">OFFICIAL</MenuItem>
                    <MenuItem value="GLOBAL">GLOBAL</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="has_prizing_image"
                        checked={
                          league.has_prizing_image === "true" ||
                          league.has_prizing_image === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Has prizing image"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="is_private"
                        checked={
                          league.is_private === "true" ||
                          league.is_private === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Is private"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="prize"
                        checked={
                          league.prize === "true" || league.prize === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Prize"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <Box>Icon</Box>
                {
                  <>
                    <input
                      accept="image/*"
                      type="file"
                      id="select-icon"
                      style={{ display: "none" }}
                      onChange={(e) => uploadFiles(e)}
                    />
                    <label htmlFor="select-icon">
                      <Iconify
                        icon="eva:plus-circle-outline"
                        sx={{
                          width: 20,
                          height: 20,
                          cursor: "pointer",
                          marginTop: 2,
                          marginBottom: 2,
                        }}
                      />
                    </label>
                    {league?.icon && (
                      <Box
                        mt={2}
                        sx={{ display: "block", margin: "0 auto" }}
                        textAlign="center"
                      >
                        <img src={league.icon} alt="" height="50x" />
                      </Box>
                    )}
                  </>
                }
              </Grid>
              <Grid item xs={12}>
                <Box>Background</Box>
                {
                  <>
                    <input
                      accept="image/*"
                      type="file"
                      id="select-background"
                      style={{ display: "none" }}
                      onChange={(e) => uploadFiles(e)}
                    />
                    <label htmlFor="select-background">
                      <Iconify
                        icon="eva:plus-circle-outline"
                        sx={{
                          width: 20,
                          height: 20,
                          cursor: "pointer",
                          marginTop: 2,
                          marginBottom: 2,
                        }}
                      />
                    </label>
                    {league?.background && (
                      <Box
                        mt={2}
                        sx={{ display: "block", margin: "0 auto" }}
                        textAlign="center"
                      >
                        <img src={league.background} alt="" height="50x" />
                      </Box>
                    )}
                  </>
                }
              </Grid>

              <Grid item xs={12}>
                <Box>Image</Box>
                {league.league_image_en ? (
                  <>
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Remy Sharp"
                      src={league.league_image_en}
                    />
                    <input
                      accept="image/*"
                      type="file"
                      id="select-image"
                      style={{ display: "none" }}
                      onChange={(e) => uploadFiles(e)}
                    />
                    <label htmlFor="select-image">
                      <Iconify
                        icon="eva:edit-outline"
                        sx={{ width: 20, height: 20, cursor: "pointer" }}
                      />
                    </label>
                    {league?.banner_url && (
                      <Box
                        mt={2}
                        sx={{ display: "block", margin: "0 auto" }}
                        textAlign="center"
                      >
                        <img src={league.banner_url} alt="" height="50x" />
                      </Box>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      accept="image/*"
                      type="file"
                      id="select-image"
                      style={{ display: "none" }}
                      onChange={(e) => uploadFiles(e)}
                    />
                    <label htmlFor="select-image">
                      <Iconify
                        icon="eva:plus-circle-outline"
                        sx={{
                          width: 20,
                          height: 20,
                          cursor: "pointer",
                          marginTop: 2,
                          marginBottom: 2,
                        }}
                      />
                    </label>
                    {league?.banner_url && (
                      <Box
                        mt={2}
                        sx={{ display: "block", margin: "0 auto" }}
                        textAlign="center"
                      >
                        <img src={league.banner_url} alt="" height="50x" />
                      </Box>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={
                !league.name ||
                !league.type ||
                !league.vanity_slug ||
                !league.sponsor_slug
              }
            >
              {props.league === null ? "Create" : "Edit"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
